import React from 'react';

const AddRestStop  = () => {
    return (
        <div>Add rest stop/open map here</div>
    )
}

export default AddRestStop;

